<template lang='pug' src='./survey-form.pug'></template>

<script>
export default {
  data: () => {
    return {
      service: '',
      availability: '',
      office: '',
      recommend: '',
      best: '',
      least: '',
      changes: '',
      formSubmitted: false
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll()
      .then(result => {
        if (result) {
          alert('Thank you for your submission!')
          this.$el.children[0].submit()
        } else {
          alert('Please make sure all fields are filled out correctly')
        }
      })
      .catch(() => {
        alert('Please make sure all fields are filled out correctly')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// survey-form.vue?5d228bc2